import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=56823692&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&lang=js"
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=56823692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56823692",
  null
  
)

export default component.exports